export default {
  create: 'Arbeitsschritt erstellen',
  edit: 'Arbeitsschritt bearbeiten',
  taskName: 'Name der Aufgabe',
};
